
import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'

const styles = theme => ({
  contents: {
    ...Contents(theme)
  },
  centred: {
    ...Centred(theme)
  },
  lead: {
    fontSize: theme.typography.subheading.fontSize,
    background: 'rgba(255,255,255,1)',
    padding: '7rem 7rem 0 7rem',
    maxWidth: 1024,
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
  suptitle: {
    textTransform: 'uppercase',
    fontSize: theme.typography.caption.fontSize
    // fontWeight: 800,
  },
  head: {
    display: 'flex',
    fontSize: theme.typography.display1.fontSize,
    fontWeight: 800,
    lineHeight: .9,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.headline.fontSize,
      wordBreak: 'break-word'
    },
  },
  share: {
    float: 'right'
  },

  author: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.typography.body1.color,
  },
  text: {
    marginTop: theme.spacing.unit * 2,
  },
  tag: {
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/lead/styles.js